import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-rc-mandataires-sociaux',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent, RouterModule],
  templateUrl: './assurance-rc-mandataires-sociaux.component.html',
  styleUrls: ['./assurance-rc-mandataires-sociaux.component.scss']
})
export class AssuranceRcMandatairesSociauxComponent {
  title = 'Assurance Responsabilité Civile Mandataires Sociaux';
  subtitle = '';
  phoneNumber = '01 42 27 12 43';
  heroImage = 'assets/static_pages_images/van_gogh.jpg';
  
  breadcrumbs = [
    { label: 'Professionnels', link: undefined },
    { label: 'RC Mandataires Sociaux', link: undefined }
  ];

  prevPage = { 
    title: 'Assurance Responsabilité Civile',
    link: '/assurance-rc-entreprise'
  };

  nextPage = { 
    title: 'Assurance Responsabilité Civile Décennale',
    link: '/assurance-rc-decennale'
  };

  constructor(private router: Router) {}

  navigateToComparison(): void {
    this.router.navigate(['/cac/comparaison']);
  }
}
